<!--
  ナビゲーターの上部です
  Lid内
-->
<template>
<div class="pa-0">
  <v-app-bar
    app
    color="white"
    clipped-left
    class="px-0 head mt-4"
    height="55px"
    width="100%"
    elevation="0"
  >
    <!--ベースタイトル-->
    <div
      class="ma-0 ml-4"
      style="background-color: #ffffff; height: 100px; width: 110px"
      v-if="unfold"
    ></div>
    <div
      class="ma-0"
      style="background-color: #294a66; height: 100px; width: 290px"
      v-else
    ></div>
    <!--ページタイトル-->
    <v-card class="ml-12 mr-8 mb-0 mt-0 pa-0 d-flex rounded-lg" elevation="2" :class='[unfold ? "width90" : "width70"]' style="border:none; height:auto;">
      <div class="ml-4" style="border-left:solid #66BAFF 11px;"></div>
      <h3 class="my-auto ml-2" v-if="aboutLid&&aboutLid.title">{{ aboutLid.title }}</h3>
      <div class="ml-auto d-flex">
        <p class="my-auto" style="font-size:12px">参加ステップ</p>
        <ol class="step text-center ml-4" style="width:25vw;">
          <li v-if="$route.name == 'content'" class="current pl-4 pb-2 pt-0" style="border-left:1px;">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/5032.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('前提情報')}}</p>
            </div>
          </li>
          <li v-else class="pl-4 pb-2 pt-0" @click="$router.push('/lid/'+$route.params.id+'/content')">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/5032.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('前提情報')}}</p>            
            </div>
          </li>
          <li v-if="$route.name == 'idea'" class="current px-4 pb-2">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/3012.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('アイデア')}}</p>
            </div>
          </li>
          <li v-else class="px-4 pb-2" @click="$router.push('/lid/'+$route.params.id+'/idea')">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/3012gray.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('アイデア')}}</p>
            </div>
          </li>
          <li v-if="$route.name == 'project'" class="current px-4 mr-2 pb-0">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/3013.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('プロジェクト')}}</p>
            </div>
          </li>
          <li v-else class="px-4 mr-2 pb-0" @click="$router.push('/lid/'+$route.params.id+'/project')">
            <div class="pa-0 d-flex flex-column text-center">
              <v-img src="../../assets/svg/3013gray.svg" width="23px" style="display: inline-block;" class="mx-auto"></v-img>
              <p class="mb-0" style="font-size:12px">{{$t('プロジェクト')}}</p>
            </div>
          </li>
        </ol>        
      </div>
    </v-card>
    <!--通知-->
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="$store.dispatch('setNotifyRead')"
          icon
        >
        <v-badge
          :content="notify_nums"
          :value="notify_nums>0"
          color="deepLava"
          overlap
        >
          <v-icon size="55px">mdi-bell-circle</v-icon>
        </v-badge>
        </v-btn>
      </template>
      <notifyList
        @openModal="openDetailNotification()"
      ></notifyList>
    </v-menu>
  </v-app-bar>
  <!--通知詳細画面-->
  <v-dialog v-model="detailNotification" width="90%" height="80%">
    <notifyDetail @closeModal="closeDetailNotification()" :sort="sort"></notifyDetail>
  </v-dialog>
  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="uid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>
</div>
</template>
<script>
import firebase from "firebase";
import profile_display from "./../profile/profile_display.vue";
import notifyList from "./../notifyList.vue";
import notifyDetail from '../notifyDetail.vue'
export default {
  props: {
    pageTitle: String,
    uid: String,
    profImageS: String,
    unfold: Boolean
  },
  components: {
    profile_display,
    notifyList,
    notifyDetail
  },
  computed: {
    basetitle() {
      return this.$store.state.basetitle;
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin
    },
    notify_nums(){
      return this.$store.state.notify_nums
    },
  },
  data() {
    return {
      profile: false,
      notifyId: "",
      detailNotification: false,
      menu: false,
      todayy: "",
      sort: ""
    };
  },
  methods: {
    /*
      プロフィール画面(profile_display)を閉じる関数
      コンポーネントから呼び出し
    */
    closeProfile() {
      this.profile = false;
    },
    openDetailNotification(el){
      this.sort = el
      this.detailNotification = true
    },
    closeDetailNotification(){
      this.detailNotification = false
    },
  },
};
</script>
<style scoped>
.width90{
  width: 83%;
}
.width70{
  width: 70%;
}
.head >>> .v-toolbar__content {
  padding-left: 0px !important;
  padding-right: 0px !important;
  z-index: 10;
}
.step{
  list-style-type: none;
  display:table;
  padding:0;
  margin:0;
  overflow:hidden;
  border-radius: 0px !important;
}
.step li{
  display:table-cell;
  position:relative;
  background: #DCDCDC;
  padding: 1em 0.5em 1em 2em;
  color: #707070;
  border-radius: 0px;
}
.step li div{
  width:100%;
}
.step li:last-child{
  padding-right: 1em;
}
.step li:last-child:before,
.step li:last-child:after{
  display:none;
}
.step li:before,
.step li:after{
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  margin: auto;
}
.step li:before{
  top:-15px;
  right:-1em;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  border-width: 40px 0 40px 1em;
  z-index: 5;
}
.step li:after{
  top:-15px;
  right:-.8em;
  border-style: solid;
  border-color: transparent transparent transparent #DCDCDC;
  border-width: 40px 0 40px 1em;
  z-index: 5;
}
.step li.current{
  background: #fff;
  color: #2B2B2B;
  font-weight: bold;
}
.step li.current:after{
  border-color: transparent transparent transparent #fff;
}
.headher {
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
}
*{
  font-family:mplus-2c-medium !important;
}
</style>